import { useState } from 'react';
import { setCurrentLanguage } from './App';
import i18n from './i18n/i18n';

const languages = [
    { code: 'vi', name: 'VIE', flag: 'vi' },  
    { code: 'en', name: 'ENG', flag: 'en' },  
];

const LanguageSelector = () => {
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
    setCurrentLanguage(language.code);
    i18n.changeLanguage(language.code);     
  };

  return (
    <div className="language-selector">
      {languages.map((language) => (
        <button key={language.code} className={`language-button ${selectedLanguage.code === language.code ? 'active' : ''}`} onClick={() => handleLanguageChange(language)}>
          <span role="img" aria-label={language.name} className="flag">
            <img src={'/images/' + language.flag + '.svg'} alt='Choose language' />
          </span>
          <span className="language-name">{language.name}</span>
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
